import React from 'react';
import get from 'lodash.get';

import AddendumFileUploaderController from '../../layouts/AddendumFileUploaderController';

const AddendumFileUploaderInput = ({
  form,
  field,
  companyId,
  label,
  handleDownload,
  uploadUrl,
  disabled,
  editable,
}) => {
  const handleUpdate = files => {
    form.setFieldTouched(field.name, true);
    form.setFieldValue(field.name, [...field.value, ...files], true);
  };

  const handleDelete = fileId => {
    form.setFieldTouched(field.name, true);
    form.setFieldValue(field.name, field.value.filter(x => x.fileId !== fileId), true);
  };

  const error = get(form, `errors[${field.name}]`, undefined);
  const touched = get(form, `touched[${field.name}]`, undefined);

  return (
    <AddendumFileUploaderController
      value={field.value}
      error={touched && error}
      companyId={companyId}
      handleUpdate={handleUpdate}
      handleDownload={handleDownload}
      handleDelete={handleDelete}
      uploaderTitle={label}
      uploadUrl={uploadUrl}
      disabled={disabled}
      editable={editable}
    />
  );
};

export default AddendumFileUploaderInput;
